<template>
    <div class="col-md-12">
        <div class="modal-header">
            <h1>Record Merge</h1>
        </div>
        <div class="modal-body">
            <pre>To Delete : {{ obj1Description }}</pre>
            <pre>to Merge : {{ obj2Description }}</pre>
        </div>
        <div class="modal-footer">
            <button
                    type="button"
                    @click="Cancel()"
                    class="btn btn-info">
                Cancel
            </button>
            <button :disabled="enblebtn" @click="Merge()" type="submit" class="btn btn-primary">
                Merge
            </button>
        </div>
    </div>
</template>

<script>
    import {
        MergeURL,
        authHeader,
        responseCheck,
        notifyHelper,
    } from "../../helper/index";
    import instance from "../../helper/http";
    export default {
        data() {
            return {
                params: {
                    objId1: "",
                    objId2: "",
                    type: ""
                },
                obj1Description: "",
                obj2Description: "",
                enblebtn: false,
            };
        },
        props: {
            obj1ID: {
                type: String,
                required: true,
            },
            obj2ID: {
                type: String,
                required: true,
            },
            obj1Desc: {
                type: String,
                required: true,
            },
            obj2Desc: {
                type: String,
                required: true,
            },
            objType: {
                type: String,
                required: true
            }
        },
        created: function () {
            this.obj1Description = this.obj1Desc.replace("null", "");
            this.obj2Description = this.obj2Desc.replace("null", "");
            this.params.objId1 = this.obj1ID;
            this.params.objId2 = this.obj2ID;
            this.params.type = this.objType;
        },
        methods: {
            Cancel() {
                this.$emit("cancel");
            },
            Merge() {
                this.enblebtn = true;
                instance
                    .get(MergeURL + "merge", {
                        headers: authHeader(),
                        params: this.params,
                    })
                    .then(() => {
                        notifyHelper("success", "Merge complete!");
                        this.$emit("done");
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    })
               
            },
        },
    };
</script>